<mat-toolbar class="header">
  <span class="title">User profile</span>
</mat-toolbar>

<div class="content">
  <div class="left-column">
  <app-card>
    <h5 class="h5">My information</h5>

    <div class="info-grid">
      <mat-form-field>
        <mat-label>First name</mat-label>
        <input
          matInput
          [formControl]="form.controls.firstName" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Last name</mat-label>
        <input
          matInput
          [formControl]="form.controls.lastName" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Email</mat-label>
        <input
          matInput
          [formControl]="form.controls.email" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Role</mat-label>
        <input
          matInput
          [formControl]="form.controls.role" />
      </mat-form-field>
    </div>
  </app-card>

  <app-card>
    <h5 class="h5">Available company</h5>

    @if (showAvailableCompanyList()) {
      <div class="available-companies">
        @for (company of availableCompanyList(); track company.id) {
          <div class="avatar-section">
            <div class="avatar">
              <mat-icon>apartment</mat-icon>
            </div>

            <div class="company-info ellipsis">
              <h3
                class="company-name ellipsis"
                [title]="company.name">
                {{ company.name }}
              </h3>
              <p class="company-id">ID: {{ company.id }}</p>
            </div>
          </div>
        }
      </div>
    } @else if (emptyAvailableCompanyList()) {
      <div class="empty-list">
        <img
          src="assets/images/icon-list.svg"
          alt="" />
        <p class="empty-text">You don't have any available companies!</p>
      </div>
    } @else {
      <div class="empty-list">
        <img
          src="assets/images/icon-list.svg"
          alt="" />
        <p class="empty-text">You manage all available companies!</p>
      </div>
    }
  </app-card>

  @if (hasSqlAccess()) {
    <app-card>
      <h5 class="h5">qa-psql token</h5>

      @if (hasSqlToken()) {
        <p class="token-status token-status--active">Token created</p>
        <div class="token-actions">
          <app-button
            variant="stroked"
            color="neutral"
            (click)="reissueToken()">
            Reissue
          </app-button>
          <app-button
            variant="stroked"
            color="warn"
            (click)="revokeToken()">
            Revoke
          </app-button>
        </div>
      } @else {
        <p class="token-status">Token not created</p>
        <app-button (click)="createToken()">Create token</app-button>
      }
    </app-card>
  }

  </div>

  <app-card class="password">
    <h5 class="h5">Change password</h5>

    <div class="form">
      <mat-form-field>
        <mat-label>Current password</mat-label>
        <input
          matInput
          [type]="passwordVisibility.current ? 'text' : 'password'"
          [formControl]="form.controls.password" />
        <mat-icon
          matSuffix
          (click)="togglePasswordVisibility('current')"
          >{{ passwordVisibility.current ? 'visibility' : 'visibility_off' }}</mat-icon
        >
      </mat-form-field>

      <mat-form-field>
        <mat-label>New password</mat-label>
        <input
          matInput
          [type]="passwordVisibility.new ? 'text' : 'password'"
          [formControl]="form.controls.passwordForm.controls.newPassword" />
        <mat-icon
          matSuffix
          (click)="togglePasswordVisibility('new')"
          >{{ passwordVisibility.new ? 'visibility' : 'visibility_off' }}</mat-icon
        >
      </mat-form-field>

      <mat-form-field>
        <mat-label>Confirm password</mat-label>
        <input
          matInput
          [type]="passwordVisibility.confirm ? 'text' : 'password'"
          [formControl]="form.controls.passwordForm.controls.confirmPassword" />
        <mat-icon
          matSuffix
          (click)="togglePasswordVisibility('confirm')"
          >{{ passwordVisibility.confirm ? 'visibility' : 'visibility_off' }}</mat-icon
        >
      </mat-form-field>
    </div>

    <section class="chips">
      @for (rule of passwordRules; track $index) {
        <div
          class="chips-item"
          [class.chips-item-ok]="!form.controls.passwordForm.errors?.[rule.key]">
          <span class="ok-icon"></span>
          <span class="text">{{ rule.label }}</span>
        </div>
      }
    </section>
  </app-card>
</div>

@if (form.touched) {
  <mat-toolbar class="footer">
    <div class="actions-buttons">
      <app-button
        variant="stroked"
        color="neutral"
        (click)="reset()">
        Reset
      </app-button>
      <app-button
        [disabled]="isSaveDisabled"
        (click)="updateUser()">
        <mat-icon>check</mat-icon>
        Save changes
      </app-button>
    </div>
  </mat-toolbar>
}
